/*eslint no-unused-vars: "off"*/
import React from "react";
import moment from "moment-timezone";

class DataTable {
  //Franchise List
  AllFranchiseList = (self) => {
    const franchiseColumns = [
      {
        title: "ID & Name",
        dataIndex: "name",
        key: "name",
        className: "tname",
        render: (text, record) => (
          <span className="type ellipse">
            {("00" + parseInt(record.id)).slice(-3)} {record.city},{" "}
            {record.state}
          </span>
        ),
      },
      {
        title: "Owner",
        dataIndex: "owner",
        key: "owner",
        className: "tname",
        render: (text, record) => (
          <span className="type ellipse">
            {record?.owner?.first_name} {record?.owner?.last_name}
          </span>
        ),
      },
      {
        title: "Address",
        dataIndex: "address",
        key: "address",
        sorter: true,
        showSorterTooltip: false,
        className: "taddress",
        render: (text) => <span className="type ellipse">{text}</span>,
      },
      {
        title: "Users",
        dataIndex: "users",
        key: "users",
        sorter: true,
        showSorterTooltip: false,
        className: "tprice",
        render: (text) => <span className="type ellipse">{text}</span>,
      },
      {
        title: "Customers",
        dataIndex: "customers",
        key: "customers",
        className: "tprice",
        render: (text) => <span className="type ellipse">{text}</span>,
      },
      {
        title: "Monthly Revenue",
        dataIndex: "monthly_revenue",
        key: "monthly_revenue",
        className: "tprice",
        render: (text) => (
          <span className="type ellipse">$ {text ? text + "k" : "-"}</span>
        ),
      },
      {
        title: "Yearly Revenue",
        dataIndex: "yearly_revenue",
        key: "yearly_revenue",
        className: "tprice",
        render: (text) => (
          <span className="type ellipse">${text ? text + "k" : "-"}</span>
        ),
      },
      {
        title: "All Time Revenue",
        dataIndex: "all_time_revenue",
        key: "all_time_revenue",
        className: "tname",
        render: (text) => (
          <span className="type ellipse">${text ? text + "m" : "-"}</span>
        ),
      },
      {
        title: "Satisfaction",
        dataIndex: "satisfaction",
        key: "satisfaction",
        className: "tprice",
        render: (text) => (
          <span className="type ellipse">{text ? text + "%" : "-"}</span>
        ),
      },
      {
        title: "Year Started",
        dataIndex: "aggrement_date",
        key: "aggrement_date",
        className: "tdate",
        render: (text) => (
          <span className="type ellipse">
            {text ? moment(text).format("YYYY") : "-"}
          </span>
        ),
      },
      {
        title: "Status",
        dataIndex: "close",
        key: "close",
        className: "tstatus",
        render: (text, record) => (
          <span className="type">
            {record.close ? (
              <b style={{ color: "#d12619" }}>Close</b>
            ) : (
              <b className="text-successs">Open</b>
            )}
          </span>
        ),
      },
      {
        title: "",
        dataIndex: "uuid",
        key: "uuid",
        className: "moreaction",
        render: (text, record) => (
          <div
            className="table_action_wrapper cursor_pointer"
            ref={(node) => {
              self.node = node;
            }}
          >
            <span
              className={
                self.state.isNav === record.uuid && self.state.openNav
                  ? "las la-ellipsis-v las_success"
                  : "las la-ellipsis-v"
              }
              onClick={(e) => {
                e.stopPropagation();
                self.ShowNav(record, text);
              }}
            ></span>

            <ul
              className={
                self.state.isNav === record.uuid && self.state.openNav
                  ? "table_Action_menu"
                  : "d-none"
              }
            >
              <li>
                <span
                  onClick={(e) => {
                    localStorage.setItem('temp_franchise', JSON.stringify({ 'data': record }))
                    e.preventDefault();
                    e.stopPropagation();
                    self.props.history.push(`/franchise/detail`, {
                      query: { data: record },
                    });
                  }}
                >
                  View
                </span>
              </li>

              <li
                disabled={self.state.is_crud_allow ? false : true}
                className={self.state.is_crud_allow ? "" : "disbale_btn"}
              >
                <span
                  onClick={(e) => {
                    if (self.state.is_crud_allow) {
                      e.preventDefault();
                      e.stopPropagation();

                      self.setState({
                        is_edit_franchise: true,
                      });
                      self.props.editFieldOffice(record.uuid);
                    }
                  }}
                >
                  Edit
                </span>
              </li>

              <li
                disabled={self.state.is_crud_allow ? false : true}
                className={self.state.is_crud_allow ? "" : "disbale_btn"}
              >
                {record.close ? (
                  <span
                    onClick={(e) => {
                      if (self.state.is_crud_allow) {
                        e.preventDefault();
                        e.stopPropagation();
                        self.setState({
                          loader: true,
                        });
                        self.props.closeFieldOffice(record.uuid);
                      }
                    }}
                  >
                    Open
                  </span>
                ) : (
                  <span
                    onClick={(e) => {
                      if (self.state.is_crud_allow) {
                        e.preventDefault();
                        e.stopPropagation();
                        self.setState({
                          loader: true,
                        });
                        self.props.closeFieldOffice(record.uuid);
                      }
                    }}
                  >
                    Close
                  </span>
                )}
              </li>
            </ul>
          </div>
        ),
      },
    ];
    return franchiseColumns;
  };
}

export default new DataTable();
